    var iScrollPos = 0;
    $(window).scroll(function () {
        var delta = 50;
        var iCurScrollPos = $(this).scrollTop();

        if(Math.abs(iScrollPos - iCurScrollPos) >= delta){
            if ((iCurScrollPos > iScrollPos) && (iCurScrollPos > 50)) {
                $("header").addClass("navbar-fixed-top fade-in").hide();
                $("#button-bar").addClass("mt-header fade-in").hide();
                $("#full-screen").hide();
                $("footer").hide().removeClass("fade-in");
            }
            else {
                var marginTop = $("header").height();
                $("header").addClass("navbar-fixed-top fade-in").show();
                $("#button-bar").addClass("mt-header fade-in").css("top", marginTop+1).show();
                if($(document).width() < 769){
                    $("footer").addClass("fade-in").show(); 
                }
                if (iCurScrollPos <= 50){
                    $("header").removeClass("navbar-fixed-top fade-in").fadeIn();
                    $("#button-bar").removeClass("mt-header fade-in").fadeIn();
                    $("#full-screen").fadeIn();
                }
            }
            iScrollPos = iCurScrollPos;
        }
    });